import trimEnd from 'lodash/trimEnd';
export const _trimEnd = trimEnd;
